var MpPageMarketplace;

(function() {
    if (!document.querySelector('#vue-marketplace')) {
        return;
    }

    MpPageMarketplace = new Vue({
        el: '#vue-marketplace',
        mixins: [MpStaticPage],

        data: {
            FILTER_ALL: 'todos',

            category: 0,
        },

        methods:{

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.category = this.$refs.categorySelector.getAttribute('data-category');
            },

            setCategory: function(category) {
                this.category = category;
            },

            isCategorySelected: function(itemCategory) {
                return this.category === this.FILTER_ALL || itemCategory === this.category;
            },
        }
    });
})();
